
import React, { useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import Sidebar from '../components/admin/Sidebar';
import Contacts from '../components/admin/Contacts';
import Quotes from '../components/admin/Quotes';
import Blogs from '../components/admin/Blogs';
import News from '../components/admin/News';
import Events from '../components/admin/Events';

const AdminPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      navigate('/admin/login');
    }
  }, [navigate]);

  return (
    <div className="flex bg-gray-100 min-h-screen">
      <Sidebar />
      <div className="flex-1 p-8 bg-white">
        <Routes>
          <Route path="contacts" element={<Contacts />} />
          <Route path="quotes" element={<Quotes />} />
          <Route path="blogs" element={<Blogs />} />
          <Route path="news" element={<News />} />
          <Route path="events" element={<Events />} />
        </Routes>
      </div>
    </div>
  );
};

export default AdminPage;

